import React, { Component } from "react";
import workprocess from "../../../data/workprocess.json";

class Workprocess extends Component {
  render() {
    return (
      <div className="section pt-6 pb-5 bg-gray">
        <div className="container ">
          <div className="row align-items-center justify-content-center mb-5">
            <div className="container text-center">
              <h3 className="title" style={{ fontSize: "50px" }}>
                Ready to Begin Your Wellness Journey ?
              </h3>
            </div>
          </div>
          <div className="row sigma_info-wrapper style-25">
            {/* Data */}
            {workprocess.map((item, i) => (
              <div className="col-lg-4 col-md-4" key={i}>
                <div className="sigma_info style-25 d-block d-xl-flex">
                  <div className="sigma_info-title">
                    <span className="sigma_info-icon">
                      <img
                        src={process.env.PUBLIC_URL + item.logoPath}
                        style={{
                          width: "42px",
                          height: "42px",
                        }}
                        alt=""
                      />
                    </span>
                  </div>
                  <div className="sigma_info-description mt-4 mt-xl-0">
                    <h5 dangerouslySetInnerHTML={{ __html: item.title }} />
                    <p>{item.text}</p>
                    <span className="steps">Step {1 + i}</span>
                    <span className="pulsive-dot" />
                  </div>
                </div>
              </div>
            ))}
            {/* Data */}
          </div>
        </div>
      </div>
    );
  }
}

export default Workprocess;
